module.exports = __webpack_public_path__ + "img/20190530160600472.61b69d73.png";